var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkToIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33333 10C1.33333 10.3667 1.63333 10.6667 2 10.6667H10C10.3667 10.6667 10.6667 10.3667 10.6667 10V6.66667C10.6667 6.3 10.9667 6 11.3333 6C11.7 6 12 6.3 12 6.66667V10.6667C12 11.4 11.4 12 10.6667 12H1.33333C0.6 12 0 11.4 0 10.6667V1.33333C0 0.6 0.593333 0 1.33333 0H5.33333C5.7 0 6 0.3 6 0.666667C6 1.03333 5.7 1.33333 5.33333 1.33333H2C1.63333 1.33333 1.33333 1.63333 1.33333 2V10ZM8 1.33333C7.63333 1.33333 7.33333 1.03333 7.33333 0.666667C7.33333 0.3 7.63333 0 8 0H12V4C12 4.36667 11.7 4.66667 11.3333 4.66667C10.9667 4.66667 10.6667 4.36667 10.6667 4V2.27333L4.58 8.36C4.32 8.62 3.9 8.62 3.64 8.36C3.38 8.1 3.38 7.68 3.64 7.42L9.72667 1.33333H8Z",
    fill: "#242057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkToIcon);
export default __webpack_public_path__ + "static/media/link-to-icon.1f72771bb8193d3bf2d330620d48e875.svg";
export { ForwardRef as ReactComponent };